





































import { Component, Vue } from "vue-property-decorator";
import OtherCompanyConstructionList from "../components/OtherCompanyConstructionList.vue";
import {
  otherCompanyConstruction,
  getOtherCompanyConstruction
} from "../../api/other-company-construction-api";
import { ServiceTaskType } from "@/servicetask/api/service-tasks-api";
import { Construction, getConstruction } from "../../api/construction-api";

@Component({
  components: {
    OtherCompanyConstructionList
  }
})
export default class OtherCompanyConstructionListPage extends Vue {
  otherCompanyConstruction: otherCompanyConstruction[] = [];
  private construction: Construction[] = [];

  public created() {
    this.loadConstructionList();
    this.loadTemplateList();
  }

  create() {
    this.$router.push({ name: "other-company-construction-new" });
  }

  private async loadConstructionList() {
    this.construction = await getConstruction();
  }
  private async loadTemplateList() {
    this.otherCompanyConstruction = await getOtherCompanyConstruction();
  }
  get templateOptions() {
    return this.$store.state.serviceTaskTypes.reduce(
      (m: Record<string, string>, t: ServiceTaskType) => {
        m[String(t.id)] = t.name;
        return m;
      },
      {}
    );
  }
  get constructionOptions() {
    return this.construction.reduce(
      (m: Record<string, string>, t: Construction) => {
        m[String(t.id)] = t.name;
        return m;
      },
      {}
    );
  }
}
